var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	},

	rowHeight: function () {
		var biggest = 0;
		var number = 0;
		$('.centerBox > * .wrapper').each(function () {
			if($(this).height() > biggest) {
				biggest = $(this).height();
				number++;
			}
		});

		if (number === 1) {
			$('.centerBox').addClass('firstBox');
		}
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		site.owl.init('#owl-hero', {
			dots: true,
			items: 1,
			autoplay: true,
			autoplayTimeout: 7000,
			autoplayHoverPause: true,
			loop: true
		});

		site.owl.init('.category.information .items', {
			nav: true,
			items: 1,
			navText: ['',''],
		});

		$('.category .items .item .count').each(function() {
			var $parent = $(this).parents('.item .content');
			$(this).appendTo($parent);
		});

		site.frontpageHeightFix.fix();
		$(window).resize(function() {
			site.frontpageHeightFix.fix();
		});


		// var $grid = $('.flytikubbar-a-forsidu .items').imagesLoaded( function() {
		// 	// init Masonry after all images have loaded
		// 	$grid.masonry({
		// 		itemSelector: '.item',
		// 		gutter: 30,
		// 		columnWidth: 1
		// 	});
		// });
	}
};

site.frontpageHeightFix = {
	fix: function() {
		var $hero = $('#owl-hero .image');
		var $items = $('.category.boxes .items');

		if ($(window).width() >= 768) {
			var $firstBox = $items.find('.item.ord-2.thumb');
			var $firstPb = $firstBox.height();
			$items.find('.item.landscape .img, item.thumb:not(.ord-2) .img').each(function () {
				$(this).css('padding-bottom', $firstPb - 1);
			});

			var $banner = $('#banner-topright');
			var $bannerHeight = $banner.height();

			$hero.css('padding-bottom', $bannerHeight);
		} else {
			$hero.css('padding-bottom', '');

			$items.find('.item .img').each(function() {
				$(this).css('padding-bottom', '');
			})
		}
	}
};

site.store = {
	init: function() {
		site.store.storeButton();
		// site.store.storePayment();
		site.store.storeCart();
		site.store.storeProductOwl();
		site.store.storePopularOwl();
	},
	storeButton: function() {
	},
	storeShowMiniCart: function($button) {
		if ($button) {
			$button.parent().addClass('pressed');
		}

		setTimeout(function() {
			if ($button) {
				$button.parent().removeClass('pressed');
			}
			$('#storeCartBox .miniCart').trigger('click');
			$('html, body').animate({
				scrollTop: $("#storeCartBox").offset().top
			}, 1000);
		},2000);
	},
	storePayment: function() {
		//Payment select for CSS
		var $store = $('#store');
		var $paymentLis = $store.find('.stepperContent.payment li');
		$paymentLis.click(function () {
			var $this = $(this);
			$paymentLis.removeClass('selected');
			if($this.find('input').prop('checked',true)) {
				$this.addClass('selected');
			}
		});
		$paymentLis.find('input:checked').each(function() {
			$(this).parents('li').trigger('click');
		});
	},
	storeCart: function() {
		var $body = $('body');
		$body.on('click', '#storeCartBox .miniCart', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');
			$('.cartBoxMedium img').responsiveImg();

			$('body.cart-open').on('click', function (e) {
				if (!$(e.target).parents('#storeCartBox').length) {
					$('body').removeClass('cart-open');
				}
			});
		});
	},

	storeProductOwl: function() {
		// var $owls = $('ul.product__owl');
		site.owl.init('ul.product__owl, #multibox #latest ul, #multibox #offers ul', {
			nav: true,
			navText: ['',''],
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				768: {
					items: 3
				},
				1200: {
					items: 4
				}
			}
		});
	},

	storePopularOwl: function () {
		site.owl.init('#popular ul', {
			nav: true,
			navText: ['', ''],
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 3
				},
				992: {
					items: 4
				}
			}
		});
	},
};

site.pageImage = {
	init:function() {
		$('label', '#elm_page_galleryImageId .lmnt').each(function() {
			var $this = $(this),
				url = $this.text();
			$this.html($this.html().replace(url, '<img alt="" src="//placehold.it/1" class="responsive" data-src="'+url+'" />'));
		});

		$('#page-tabs').on('tabsactivate', function(event, ui) {
			if (ui.newTab.index() == 3) {
				$("img.responsive").responsiveImg();
			}
		});
	}
};

site.sidebar = {
	init:function() {
		site.sidebar.setMinHeight();

		$(window).resize(function() {
			site.sidebar.setMinHeight();
		});
	},

	setMinHeight: function() {
		var $body = $('body');
		var $main = $body.find('#main');
		if (!$body.is('.hideright') ) {
			var $sidebar = $('#sidebar');
			if ($sidebar.find('li').length) {
				var $children = $main.find('> .box');
				if ($children.length) {
					var $sidebarHeight = $('#sidebar').height();
					if ($sidebarHeight > 0) {
						$children.first().css('min-height', $sidebarHeight);
					} else {
						$children.first().css('min-height', '');
					}
				}
			}
		}
	}
};

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('#title', '.boxmanBoxForm').length > 0;
			}, function () {
				$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
				$('#categories').multiselect({
					sortable: true,
					searchable: false
				});
			}, function () {
			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

site.multibox = {
	init: function() {
		$('#multibox').on('click', function(e) {
			if (!e.target.classList.contains('ui-tabs-anchor')) {
				return;
			}
			$('img.responsive').responsiveImg();
		});
	}
}

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	site.accessibility.init();
	site.store.init();
	site.faq.init();
	site.sidebar.init();
	site.multibox.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	site.layout.rowWrap('.box_social_instagram', '.box_social_facebook', 'centerBox');
	site.layout.rowHeight();

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

store = window.store || {};
store.local = store.local || {};

store.local.updateMiniCart = function (autoOpenSite) {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
		if (autoOpenSite) {
			site.store.storeShowMiniCart();
		}
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function () {
	$('body').removeClass('emptyCart');
	store.local.updateMiniCart(true);
};

store.local.onCartIncrease = function () {
	store.local.updateMiniCart(false);
};

store.local.onCartDecrease = function () {
	store.local.updateMiniCart(false);
};

site.faq = {
	init : function() {
		var $faq = $('body.faq,#main .box_faqCategory');
		if ($faq.length === 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
			window.history.replaceState(null, null, "#" + $(this).attr('id'));
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});

		if(window.location.hash.length > 0) {
			let codename = window.location.hash;
			let question = $(codename);

			if(question.length > 0 && question.height() < 40) {
				let showMore = $('.faq__showmore');
				showMore.prev().find('.q').addClass('show');
				showMore.addClass('hidden');

				('.answer', $faq).each(function() {
					$(this).css('max-height', $(this)[0].scrollHeight);
				});

				setTimeout(function() {
					question.trigger('click');
				}, 400);

				setTimeout(function() {
					document.querySelector(codename).scrollIntoView({
						behavior: 'smooth'
					});
				}, 500);


			}
		}

		$('.faq__showmore', $faq).on('click', function() {
			$(this).prev().find('.q').addClass('show');
			$(this).addClass('hidden');

			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});
	}
};
store.local.___attrHack1 = false;
store.local.onSelectVariant = function() {
	if (!store.local.___attrHack1) {
		store.local.___attrHack1 = true;
		document.querySelectorAll('#store .buyBox .variantSelection .attribute select').forEach(function(el) {
			var lmnt = document.createElement('div');
			lmnt.classList.add('lmnt');
			el.parentNode.insertBefore(lmnt, el);
			lmnt.appendChild(el);
		});
	}
};
